import { useState, useEffect } from 'react'
import { testimonialService, type TestimonialWithId } from '../services/testimonial.service'

interface UseApprovedTestimonialsResult {
  testimonials: TestimonialWithId[]
  loading: boolean
}

export function useApprovedTestimonials(): UseApprovedTestimonialsResult {
  const [testimonials, setTestimonials] = useState<TestimonialWithId[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    testimonialService
      .getApproved()
      .then(setTestimonials)
      .catch(() => setTestimonials([]))
      .finally(() => setLoading(false))
  }, [])

  return { testimonials, loading }
}
